/**
 * Thin wrapper around livekit-client. Most of the UI uses
 * @livekit/components-react primitives directly via <LiveKitRoom>; this
 * module just owns the contract for token minting + room URL resolution
 * and exposes a few helpers tests can mock.
 */
import { ApiPaths, api } from "./api";

export type LiveKitMintInput = {
  room: string;
  role: "operator" | "observer" | "auditor";
  identity?: string;
  ttl_minutes?: number;
};

export type LiveKitMintResponse = {
  token: string;
  url: string;
  room: string;
  identity: string;
};

export async function mintLiveKitToken(input: LiveKitMintInput): Promise<LiveKitMintResponse> {
  const res = await api.post<LiveKitMintResponse>(ApiPaths.livekitToken, input);
  return res.data;
}

/** Choose the WSS URL the browser actually connects to. The backend
 * supplies it on every mint; the env var is a fallback for cases where the
 * frontend already knows the deployment (rare). */
export function pickLiveKitUrl(serverUrl: string | undefined): string {
  if (serverUrl) return serverUrl;
  return (import.meta.env.VITE_LIVEKIT_WS_URL as string | undefined) ?? "";
}